import { render, staticRenderFns } from "./home-icon.vue?vue&type=template&id=207306ec&functional=true&"
import script from "./home-icon.vue?vue&type=script&lang=js&"
export * from "./home-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports